<template>
  <div>
    <SelectPicture @cropped="updateProfilePhoto($event)"
                   v-model="showSelectPicture">
    </SelectPicture>

    <ChangePassword v-model="showChangePassword"/>

    <CreateShortLink v-model="showCreateShortLinkDialog"/>

    <v-menu id="menuProfileOpt"
            offset-y
            origin="top right"
            bottom
            :nudge-bottom="3"
            :nudge-left="170"
            transition="scale-transition"
            open-on-hover
            open-on-click>
      <template v-slot:activator="{ on }">
        <v-chip id="profileBtn"
                color="transparent"
                text-color="kbWhite"
                class="px-1 mx-1"
                v-on="on">
          <v-avatar size="30px" color="transparent">
            <v-icon small color="white">face</v-icon>
          </v-avatar>
          <v-icon color="white"
                  class="hidden-xs-only"
                  right>
            arrow_drop_down
          </v-icon>
        </v-chip>
      </template>

      <v-list class="pa-0 kbWhite">
        <v-row no-gutters>
          <v-col class="text-center my-2">
            <div style="position: relative; display: inline-flex">
              <v-avatar size="100px">
                <template v-if="imageProfile">
                  <v-img :src="imageProfile"
                         @error="onErrorImage()">
                  </v-img>
                </template>

                <template v-else>
                  <v-icon @click="showSelectPicture = true"
                          style="border: solid 1px rgba(0,0,0,.1)"
                          large>
                    mdi-face
                  </v-icon>
                </template>
              </v-avatar>

              <v-btn fab x-small elevation="1" style="position: absolute; bottom: 0; right: 0">
                <v-icon @click="showSelectPicture = true"
                        x-small>
                  mdi-camera
                </v-icon>
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" class="text-center">
            {{ userKeybe.name }}
          </v-col>

          <v-col cols="12" class="text-caption grey--text text-center mb-2">
            {{ userKeybe.email }}
          </v-col>
        </v-row>

        <v-divider/>

        <v-list-item @click="openChat()" class="hidden-xl-only">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">mdi-face-agent</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('toolbar.support') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openChangePasswordDialog()">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">lock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('toolbar.changePassword') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openCreateShortLinkDialog()">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">link</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('toolbar.shortenLink') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout()">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">
              exit_to_app
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('toolbar.exit') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import ChangePassword from '@/components/dialogs/ChangePassword.vue'
import CreateShortLink from '@/components/dialogs/CreateShortLink.vue'
import SelectPicture from '@/pages/App/KeybeUi/SelectPicture.vue'
export default {
  components: { ChangePassword, CreateShortLink, SelectPicture },
  computed: {
    ...mapState({
      userKeybe: state => state.auth.userKeybe
    }),
    imageProfile () {
      if (this.errorImageProfile) return ''
      return this.userKeybe.image || this.userKeybe.photo
    }
  },
  data () {
    return {
      errorImageProfile: false,
      showChangePassword: false,
      showCreateShortLinkDialog: false,
      showSelectPicture: false
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    },
    onErrorImage () {
      this.errorImageProfile = true
    },
    openChangePasswordDialog () {
      this.showChangePassword = true
    },
    openChat () {
      window.keybe.openChat()
    },
    openCreateShortLinkDialog () {
      this.showCreateShortLinkDialog = true
    },
    async updateProfilePhoto (image) {
      try {
        const data = {
          administratorId: this.userKeybe.userId,
          photo: image.url,
          userType: this.userKeybe.type
        }

        const response = await this.$store.dispatch('updateAdministrator', data)
        this.$store.commit('SET_KEYBE_USER', response.user)
        this.showSelectPicture = false
        notifications.success(this.$t('general.profilePicUpdated'))
      } catch (e) {
        notifications.error(e.message)
      }
    }
  }
}
</script>
